var map = {
	"./amenities_amazon_locker.svg": 67949,
	"./amenities_amazon_locker_HK.png": 97774,
	"./amenities_amazon_locker_MO.png": 9785,
	"./amenities_atm.svg": 25650,
	"./amenities_billa_AT.svg": 55722,
	"./amenities_billa_CZ.svg": 39730,
	"./amenities_budgens.svg": 21130,
	"./amenities_carwash.svg": 36057,
	"./amenities_co_op.svg": 67650,
	"./amenities_costa.png": 85591,
	"./amenities_costa_express.svg": 37511,
	"./amenities_deli2go.svg": 24414,
	"./amenities_deli_by_shell.svg": 75781,
	"./amenities_deli_cafe.svg": 51658,
	"./amenities_deliveroo.svg": 39991,
	"./amenities_disability_assistance.svg": 37191,
	"./amenities_freshii.svg": 61684,
	"./amenities_heavy_duty_ev.svg": 60700,
	"./amenities_in_post.jpg": 57725,
	"./amenities_jamie_oliver_deli_by_shell.jpg": 8985,
	"./amenities_john_lewis_click_and_collect.svg": 37060,
	"./amenities_karcher_car_wash.svg": 73927,
	"./amenities_manual_HK.svg": 98872,
	"./amenities_mcdonalds.png": 14160,
	"./amenities_mcx_CH.png": 79629,
	"./amenities_migrolino.svg": 22466,
	"./amenities_mio_shop_CH.png": 7741,
	"./amenities_mobile_payment.svg": 22247,
	"./amenities_partner_fleet_card_AR.svg": 39040,
	"./amenities_recup.svg": 51099,
	"./amenities_returns.jpg": 17178,
	"./amenities_rollover_HK.svg": 99699,
	"./amenities_selectshop.jpg": 37215,
	"./amenities_shell_cafe.svg": 44620,
	"./amenities_shop.svg": 84290,
	"./amenities_standard_toilet.svg": 42003,
	"./amenities_starbucks.svg": 37654,
	"./amenities_starbucks_DE.png": 71601,
	"./amenities_tim_hortons.svg": 37064,
	"./amenities_twotheloo.svg": 24409,
	"./amenities_uber_eats.png": 17921,
	"./amenities_waitrose.svg": 48508,
	"./destination_host_aldi.png": 945,
	"./destination_host_gamma.png": 14208,
	"./destination_host_haje.svg": 40336,
	"./destination_host_karwei.svg": 42389,
	"./destination_host_kfc.png": 29469,
	"./destination_host_penny.png": 96997,
	"./destination_host_rewe.jpg": 37440,
	"./destination_host_tesco.png": 5653,
	"./ev-connectors_domestic.svg": 35479,
	"./ev-connectors_gbt_ac.svg": 33223,
	"./ev-connectors_gbt_dc.svg": 4576,
	"./ev-connectors_other.svg": 97231,
	"./ev-connectors_tepco_chademo.svg": 89122,
	"./ev-connectors_tesla.svg": 58788,
	"./ev-connectors_type_1.svg": 33919,
	"./ev-connectors_type_1_combo.svg": 49304,
	"./ev-connectors_type_2.svg": 78572,
	"./ev-connectors_type_2_combo.svg": 5839,
	"./ev-connectors_type_3.svg": 58285,
	"./ev-connectors_unspecified.svg": 49804,
	"./fuels_hydrogen.svg": 73660,
	"./fuels_shell_recharge.svg": 12170,
	"./fuels_shell_recharge_AT.svg": 41426,
	"./lube_products_rotella.png": 53434,
	"./lube_products_shell_rotella_gas_truck_motor_oil.png": 15792,
	"./premier_types_premier_hdi.png": 11188,
	"./promotions_mmm.png": 75875,
	"./truck_services_heavy_duty_ev.svg": 7209
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58234;